var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:_vm.iconClass,style:(_vm.iconStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }